// PayoutSettingsCard.jsx
import React from "react";
import { Card, Button } from "react-bootstrap";
import image from "../../../assets/home-payout-setting-card-logo.png";
import { Link } from "react-router-dom";
const HomePayoutSettingCard = () => {
  return (
    <Card className="dod-dash-main-page-payout-settings-card">
      <div className="ps-lg-5 pe-lg-5 ps-4 pe-4 pt-4 pb-4 d-flex flex-column align-items-center justify-content-center">
        <img src={image} alt="Question Mark" width="69" height="70"></img>
        <h5 className="ob-supplier-content-heading text-center mt-3">
          Tell us how to pay you
        </h5>
        <p className="ob-having-trouble-card-description text-center">
          Select your preferred currency and add your bank details
        </p>

        <Link
          style={{ textDecoration: "none" }}
          to={"/edit-profile"}
          onClick={() => {
            localStorage.setItem("DODEditProfileActiveComponent", 5);
          }}
          className="submit-btn"
        >
          Add payout settings
        </Link>
      </div>
    </Card>
  );
};

export default HomePayoutSettingCard;
